/**
 * @param {number} count
 * @param {string} few
 * @param {string} one
 * @param {string} two
 * @returns {string}
 */
function declineNumber(count, few, one, two) {
  if (isNaN(parseInt(count))) {
    return one;
  }

  if (parseInt(count) !== +count) {
    return few;
  }

  count = Math.abs(count);

  if (count % 100 > 4 && count % 100 < 21) {
    return few;
  }

  if (count % 10 > 1 && count % 10 < 5) {
    return two;
  }

  if (count % 10 === 1) {
    return one;
  }

  return few;
}

module.exports = declineNumber;
